module.exports = __webpack_public_path__ + "2fcd44fcce6d127b4ab0ccbf90fa963a.png";